import React from 'react';
import './Header.scss';

export function Header() {
  return (
    <header className="header">
      <div className="header__content">
        <img
          src="/ClinicTech_logo_mark.png"
          alt="ClinicTech"
          className="header__logo"
        />
      </div>
    </header>
  );
}

export default Header;
